import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => {
  return {
    actionWrapper: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      padding: '0.5rem 0.5rem 0.5rem 0'
    }
  };
});

export default useStyles;
